/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserProfileSchema } from './UserProfileSchema';
import {
    UserProfileSchemaFromJSON,
    UserProfileSchemaFromJSONTyped,
    UserProfileSchemaToJSON,
} from './UserProfileSchema';

/**
 * 
 * @export
 * @interface OrganizationMembershipUserSchema
 */
export interface OrganizationMembershipUserSchema {
    /**
     * 
     * @type {number}
     * @memberof OrganizationMembershipUserSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationMembershipUserSchema
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationMembershipUserSchema
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationMembershipUserSchema
     */
    preferredName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationMembershipUserSchema
     */
    email: string;
    /**
     * 
     * @type {UserProfileSchema}
     * @memberof OrganizationMembershipUserSchema
     */
    profile: UserProfileSchema;
}

/**
 * Check if a given object implements the OrganizationMembershipUserSchema interface.
 */
export function instanceOfOrganizationMembershipUserSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "fullName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "profile" in value;

    return isInstance;
}

export function OrganizationMembershipUserSchemaFromJSON(json: any): OrganizationMembershipUserSchema {
    return OrganizationMembershipUserSchemaFromJSONTyped(json, false);
}

export function OrganizationMembershipUserSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationMembershipUserSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
        'fullName': json['full_name'],
        'preferredName': !exists(json, 'preferred_name') ? undefined : json['preferred_name'],
        'email': json['email'],
        'profile': UserProfileSchemaFromJSON(json['profile']),
    };
}

export function OrganizationMembershipUserSchemaToJSON(value?: OrganizationMembershipUserSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'username': value.username,
        'full_name': value.fullName,
        'preferred_name': value.preferredName,
        'email': value.email,
        'profile': UserProfileSchemaToJSON(value.profile),
    };
}

